import { TransactionFlow, TransactionType } from '../enums';
export function isPixUnderReview(transaction) {
    return (transaction.type === TransactionType.PIX &&
        transaction.status === 'PENDING' &&
        (transaction.flow === TransactionFlow.CASH_IN || transaction.flow === TransactionFlow.CASH_OUT));
}
